import { TemplateType } from '@/types/boot';
import { TemplateConfigurations, type TemplateFeatures } from '@/constants/templateConfig';
import { DefaultView } from '@/templateViews/DefaultView';
import { pickFirstNonExpressPaymentMethod } from '@/utils/paymentMethodResolvers';
import {
  CheckoutTemplate,
  type PaymentMethodSelectionContext,
  type TemplateInitContext,
  type TemplateView,
} from './CheckoutTemplate';

/**
 * Standard full-screen checkout: hero + every available payment method.
 * Always eligible; the registry uses this as the fallback when any other
 * template is unavailable or unknown.
 */
export class DefaultTemplate extends CheckoutTemplate {
  readonly type: TemplateType = TemplateType.DEFAULT;
  readonly View: TemplateView = DefaultView;
  readonly features: TemplateFeatures = TemplateConfigurations[TemplateType.DEFAULT];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isEligible(_ctx: TemplateInitContext): boolean {
    return true;
  }

  resolveDefaultPaymentMethod({ paymentMethods }: PaymentMethodSelectionContext) {
    return pickFirstNonExpressPaymentMethod(paymentMethods);
  }
}
